{
  "schemaVersion": 1,
  "packId": "ccd-0-12-2026-09",
  "ageBands": ["birth-1-week", "1-week-6-months", "6-9-months", "9-12-months"],
  "activities": [
    {
      "activityId": "ccd.birth-1-week.gentle-sensory-contact",
      "skillId": "early.relationship.gentle-sensory-contact.birth-1-week",
      "title": "Vedere, sentire e toccare con calma",
      "ageBands": ["birth-1-week"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Relazione, regolazione e prime esperienze sensoriali",
      "objective": "Guidare il caregiver a offrire al neonato una breve esperienza calma di voce, contatto e movimento libero, seguendo i suoi segnali senza richiedere alcuna risposta.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · NEWBORN, BIRTH UP TO 1 WEEK · PLAY; Participant Manual · Recommendations for Care for Child Development",
          "rationale": "CCD afferma che il bambino apprende dalla nascita e raccomanda opportunità per vedere, sentire, muovere liberamente braccia e gambe e toccare il caregiver, con contenimento e contatto gentili."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · cura, relazione, corporeità, esperienza e ascolto dei segnali del bambino",
          "rationale": "La proposta mantiene l'adulto come presenza responsiva e parte dall'esperienza corporea e relazionale, senza trasformare l'interazione in esercizio prestazionale."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "Il dispositivo serve solo a mostrare la consegna al caregiver e viene poi messo da parte; il neonato non svolge attività sullo schermo."
        }
      ],
      "materials": ["Nessun materiale obbligatorio; bastano la presenza, la voce e il contatto del caregiver"],
      "safetyConstraints": [
        "L'interazione deve avvenire con un adulto vigile e in una posizione stabile e sicura per il neonato.",
        "Non scuotere, non forzare movimenti e non usare stimoli intensi, luminosi o rumorosi.",
        "Se il neonato è prematuro, fragile o ha indicazioni cliniche specifiche, seguire le istruzioni del team sanitario che lo assiste.",
        "Questa attività non sostituisce indicazioni su sonno sicuro, alimentazione o assistenza sanitaria."
      ],
      "observationSignals": [
        "Il caregiver rallenta e osserva i segnali del neonato durante l'interazione.",
        "Il neonato può restare tranquillo, guardare, muoversi, vocalizzare oppure distogliersi: nessuna risposta è richiesta.",
        "L'adulto interrompe o modifica spontaneamente l'interazione quando il neonato mostra bisogno di pausa."
      ],
      "adaptation": {
        "ifEasy": "Mantenere la stessa interazione breve e tranquilla, variando solo voce o posizione del proprio volto senza aumentare l'intensità.",
        "ifHard": "Ridurre gli stimoli: restare semplicemente vicini, parlare piano o tenere il neonato con calma se appropriato.",
        "stopRule": "Interrompere subito se il neonato mostra disagio, pianto crescente, affaticamento o necessità di cura, alimentazione o riposo."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 15 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.birth-1-week.eye-contact-talk",
      "skillId": "early.communication.eye-contact-talk.birth-1-week",
      "title": "Sguardo e voce del caregiver",
      "ageBands": ["birth-1-week"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione e relazione responsiva",
      "objective": "Invitare il caregiver a guardare il volto del neonato e parlargli con voce calma durante un momento naturale di cura, senza aspettarsi una prestazione.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · NEWBORN, BIRTH UP TO 1 WEEK · COMMUNICATE; Participant Manual · Recommendations",
          "rationale": "CCD raccomanda di guardare negli occhi il neonato e parlargli, sottolineando che già alla nascita vede il volto e sente la voce del caregiver."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · comunicazione, relazione, ascolto e qualità dei momenti di cura",
          "rationale": "La proposta integra comunicazione e relazione nei normali momenti di cura e rispetta i tempi individuali del bambino."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "L'interazione avviene faccia a faccia; lo schermo è usato esclusivamente dall'adulto per leggere la breve guida."
        }
      ],
      "materials": ["Nessun materiale obbligatorio"],
      "safetyConstraints": [
        "Scegliere un momento in cui il neonato è accudito in modo sicuro e l'adulto può prestare attenzione.",
        "Non cercare di mantenere forzatamente il contatto visivo e non interpretarne l'assenza come problema.",
        "Usare un tono naturale e calmo; evitare stimolazione eccessiva."
      ],
      "observationSignals": [
        "L'adulto prova a creare un breve momento di presenza e voce condivisa.",
        "Il neonato può guardare il volto, muoversi, vocalizzare, chiudere gli occhi o distogliersi.",
        "Il caregiver segue i segnali del neonato invece di prolungare l'interazione a tutti i costi."
      ],
      "adaptation": {
        "ifEasy": "Proseguire per pochi istanti con una frase semplice o un suono dolce, mantenendo il ritmo del neonato.",
        "ifHard": "Limitarsi a una presenza tranquilla e a poche parole, senza cercare una risposta.",
        "stopRule": "Fermarsi quando il neonato distoglie l'attenzione, si addormenta, piange o necessita di altra cura."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 15 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.1w-6m.follow-safe-object",
      "skillId": "early.play.follow-safe-object.1w-6m",
      "title": "Seguire un oggetto grande e sicuro",
      "ageBands": ["1-week-6-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Esplorazione visiva, movimento e relazione",
      "objective": "Offrire una breve occasione per vedere e, quando il bambino lo desidera, provare a raggiungere un oggetto grande e sicuro mosso lentamente dal caregiver.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · 1 WEEK UP TO 6 MONTHS · PLAY; Participant Manual · Recommendations",
          "rationale": "CCD raccomanda opportunità per vedere, sentire, percepire e muoversi liberamente e suggerisce di muovere lentamente oggetti colorati affinché il bambino possa vederli e provare a raggiungerli."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esplorazione, corporeità, movimento, relazione e iniziativa del bambino",
          "rationale": "L'attività è breve, concreta e guidata dall'interesse del bambino, con l'adulto che sostiene senza dirigere rigidamente."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "Si usa un oggetto reale; il telefono non diventa lo stimolo visivo del bambino."
        }
      ],
      "materials": ["Un solo oggetto grande, leggero, pulito, adatto all'età, senza parti staccabili e facile da afferrare quando appropriato"],
      "safetyConstraints": [
        "L'oggetto deve essere adatto all'età e non presentare rischio di soffocamento, strangolamento, taglio o impatto.",
        "Non usare corde, lacci o piccoli anelli fissati all'oggetto.",
        "Muovere lentamente l'oggetto senza avvicinarlo bruscamente al viso e senza forzare il bambino a seguirlo o afferrarlo.",
        "Supervisione continua dell'adulto."
      ],
      "observationSignals": [
        "Il bambino può guardare l'oggetto, muovere braccia o gambe, provare a raggiungerlo oppure ignorarlo.",
        "Il caregiver adatta velocità e distanza ai segnali del bambino.",
        "L'interazione resta breve e piacevole."
      ],
      "adaptation": {
        "ifEasy": "Spostare lentamente l'oggetto in una seconda direzione o lasciare che il bambino lo tocchi se è sicuro e appropriato.",
        "ifHard": "Tenere l'oggetto quasi fermo e più vicino al normale campo visivo, riducendo il movimento.",
        "stopRule": "Interrompere quando il bambino distoglie l'attenzione, mostra stanchezza o disagio oppure l'oggetto non resta sicuro."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 20 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.1w-6m.copy-sounds-gestures",
      "skillId": "early.communication.copy-sounds-gestures.1w-6m",
      "title": "Conversazione di suoni e sorrisi",
      "ageBands": ["1-week-6-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione, reciprocità e relazione",
      "objective": "Aiutare il caregiver a creare un semplice scambio responsivo parlando, sorridendo e copiando con delicatezza suoni o gesti spontanei del bambino.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · 1 WEEK UP TO 6 MONTHS · COMMUNICATE; Participant Manual · Recommendations",
          "rationale": "CCD raccomanda di sorridere e ridere con il bambino, parlargli e avviare una conversazione copiando i suoi suoni o gesti."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · comunicazione, ascolto, reciprocità e molteplici linguaggi",
          "rationale": "Lo scambio parte dalle iniziative comunicative del bambino e valorizza la risposta sensibile dell'adulto."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "La relazione è diretta tra adulto e bambino; il dispositivo viene messo da parte dopo la consegna."
        }
      ],
      "materials": ["Nessun materiale obbligatorio"],
      "safetyConstraints": [
        "Non richiedere al bambino di ripetere un suono o gesto e non trasformare lo scambio in una prova.",
        "Mantenere voce e mimica naturali senza suoni improvvisi o eccessivamente forti.",
        "Rispettare pause, sguardo distolto, sonno, fame o segnali di sovrastimolazione."
      ],
      "observationSignals": [
        "Il caregiver nota un suono, un movimento o un'espressione e prova a rispondere.",
        "Il bambino può rispondere a sua volta oppure limitarsi ad ascoltare o osservare.",
        "L'adulto lascia pause sufficienti e segue il ritmo del bambino."
      ],
      "adaptation": {
        "ifEasy": "Continuare per uno o due turni di scambio, lasciando sempre una pausa dopo la risposta dell'adulto.",
        "ifHard": "Limitarsi a parlare con calma e sorridere quando il bambino è disponibile, senza imitazione obbligatoria.",
        "stopRule": "Concludere appena il bambino segnala stanchezza, disinteresse o disagio."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 15 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.6-9.handle-bang-drop-safe",
      "skillId": "early.play.handle-bang-drop.6-9",
      "title": "Maneggiare, battere e lasciar cadere in sicurezza",
      "ageBands": ["6-9-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Esplorazione, causa-effetto e coordinazione",
      "objective": "Offrire pochi oggetti grandi e sicuri da esplorare, battere delicatamente o lasciar cadere, permettendo al bambino di sperimentare suoni e conseguenze delle proprie azioni.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · 6 MONTHS UP TO 9 MONTHS · PLAY; Participant Manual · Recommendations · 6 months up to 9 months · p. 15",
          "rationale": "CCD raccomanda oggetti domestici puliti e sicuri da maneggiare, battere e lasciar cadere e descrive l'esplorazione di suono, caduta e movimento come apprendimento."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · gioco, esplorazione, esperienza concreta, movimento e scoperta",
          "rationale": "L'attività valorizza esplorazione autonoma e ripetizione, con l'adulto che prepara un ambiente sicuro e responsivo."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "L'esperienza è fisica e fuori dallo schermo; l'app dà solo istruzioni all'adulto."
        }
      ],
      "materials": ["2–3 oggetti grandi, leggeri, puliti e progettati o verificati come sicuri per l'età, con superfici non taglienti"],
      "safetyConstraints": [
        "Supervisione continua e area libera da piccoli oggetti, vetro, liquidi caldi, metallo pesante o bordi taglienti.",
        "Non usare contenitori con coperchi che possano intrappolare dita o parti del corpo.",
        "Evitare oggetti rumorosi a livelli intensi e qualunque parte staccabile o ingeribile.",
        "Lasciare cadere gli oggetti solo da una posizione bassa e sicura."
      ],
      "observationSignals": [
        "Il bambino esplora uno o più oggetti con mani, sguardo o movimento.",
        "Il bambino può ripetere un'azione per osservare suono, movimento o caduta.",
        "Il caregiver segue l'interesse senza interrompere continuamente la sperimentazione sicura."
      ],
      "adaptation": {
        "ifEasy": "Sostituire un solo oggetto con uno di consistenza o suono diverso, mantenendo lo stesso schema esplorativo.",
        "ifHard": "Offrire un solo oggetto semplice e mostrare una volta un'azione delicata, poi attendere senza forzare.",
        "stopRule": "Fermarsi se il bambino perde interesse, si irrita, appare stanco o qualunque oggetto diventa non sicuro."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 20 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.6-9.respond-name-interests",
      "skillId": "early.communication.respond-name-interests.6-9",
      "title": "Rispondere a suoni, interessi e nome",
      "ageBands": ["6-9-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione e attenzione condivisa",
      "objective": "Allenare il caregiver, non il bambino, a rispondere ai suoni e agli interessi mostrati dal piccolo e a usare il suo nome con tono affettuoso durante lo scambio.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · 6 MONTHS UP TO 9 MONTHS · COMMUNICATE; Participant Manual · Recommendations · p. 15",
          "rationale": "CCD raccomanda di rispondere ai suoni e agli interessi del bambino e di chiamarlo per nome, osservando la risposta senza presentarla come test."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · relazione responsiva, comunicazione, ascolto e identità",
          "rationale": "La proposta centra la qualità della risposta adulta e il riconoscimento dell'iniziativa del bambino."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "Il dispositivo non viene usato per ottenere l'attenzione del bambino; lo scambio avviene direttamente con il caregiver."
        }
      ],
      "materials": ["Nessun materiale obbligatorio; si può seguire un oggetto o evento che interessa già il bambino"],
      "safetyConstraints": [
        "Non ripetere insistentemente il nome per verificare una risposta.",
        "Non interpretare una mancata risposta in una singola occasione come indicazione diagnostica.",
        "Seguire ciò che il bambino sta già guardando o facendo, senza sottrargli bruscamente l'oggetto di interesse."
      ],
      "observationSignals": [
        "Il caregiver nota un suono, uno sguardo o un interesse e vi risponde.",
        "Il bambino può guardare, vocalizzare, muoversi o continuare la propria esplorazione.",
        "Lo scambio resta affettuoso e non valutativo."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere una semplice parola sull'oggetto o evento che interessa il bambino e attendere la sua iniziativa successiva.",
        "ifHard": "Limitarsi a seguire lo sguardo o il gesto del bambino e commentare con una sola parola o breve frase.",
        "stopRule": "Interrompere le sollecitazioni quando il bambino si distoglie, è stanco, irritato o interessato ad altro."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 15 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.9-12.find-hidden-toy",
      "skillId": "early.play.find-hidden-toy.9-12",
      "title": "Trovare il gioco nascosto e cucù",
      "ageBands": ["9-12-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Gioco, esplorazione e permanenza dell'oggetto",
      "objective": "Nascondere parzialmente o completamente un gioco familiare e sicuro sotto un telo leggero appoggiato al piano, lasciando al bambino libertà di cercarlo; alternare, se gradito, con un semplice gioco di cucù.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · 9 MONTHS UP TO 12 MONTHS · PLAY; Health Worker's Manual · For the child, from 9 months up to 12 months · p. 17",
          "rationale": "CCD raccomanda di nascondere un gioco preferito sotto un panno o una scatola e vedere se il bambino lo trova, oltre al gioco del cucù."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · gioco, esplorazione, iniziativa, relazione e scoperta",
          "rationale": "Il bambino conduce la ricerca nel gioco reale e l'adulto sostiene senza correggere o misurare la prestazione."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "Il gioco usa materiali reali e interazione faccia a faccia, non immagini o animazioni sul dispositivo."
        }
      ],
      "materials": ["Un gioco familiare grande e sicuro", "Un piccolo telo leggero usato solo sul piano di gioco oppure una scatola ampia e aperta"],
      "safetyConstraints": [
        "Non coprire mai il volto o il corpo del bambino con il telo e non lasciare tessuti o scatole con il bambino senza supervisione.",
        "Il gioco deve essere adatto all'età, non ingeribile e privo di parti staccabili.",
        "La scatola deve restare aperta e non poter intrappolare mani, testa o corpo.",
        "Non insistere affinché il bambino trovi l'oggetto."
      ],
      "observationSignals": [
        "Il bambino può cercare, sollevare il telo, guardare la scatola oppure preferire un'altra azione.",
        "Il caregiver lascia tempo e può mostrare una sola volta senza trasformare il gioco in prova.",
        "Il bambino segnala con il proprio comportamento se desidera ripetere il gioco."
      ],
      "adaptation": {
        "ifEasy": "Nascondere il gioco un po' di più oppure cambiare posizione una sola volta, mantenendolo facilmente accessibile.",
        "ifHard": "Lasciare una parte ampia del gioco visibile o usare soltanto il cucù faccia a faccia senza materiali.",
        "stopRule": "Fermarsi quando il bambino perde interesse, si irrita o cerca di usare telo/scatola in modo non sicuro."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 20 },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.9-12.names-and-gestures",
      "skillId": "early.communication.names-gestures.9-12",
      "title": "Nomi delle cose e gesti sociali",
      "ageBands": ["9-12-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione, gesti e attenzione condivisa",
      "objective": "Nominare in modo semplice persone e cose già presenti nell'ambiente e mostrare un gesto sociale naturale, come salutare con la mano, lasciando al bambino piena libertà di osservare o imitare.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Counselling Cards · 9 MONTHS UP TO 12 MONTHS · COMMUNICATE; Health Worker's Manual · p. 17",
          "rationale": "CCD raccomanda di dire al bambino i nomi di cose e persone e di mostrare come comunicare con le mani, per esempio facendo ciao."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · comunicazione, linguaggi, relazione, identità e quotidianità",
          "rationale": "Parole e gesti sono integrati in situazioni reali e familiari, rispettando iniziativa e tempi individuali."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · infants less than 1 year · sedentary screen time is not recommended",
          "rationale": "L'adulto usa persone e oggetti reali; non mostra video o flashcard al bambino."
        }
      ],
      "materials": ["Nessun materiale obbligatorio; usare persone e oggetti familiari già presenti"],
      "safetyConstraints": [
        "Non chiedere ripetutamente al bambino di indicare, nominare o imitare come forma di verifica.",
        "Non interpretare l'assenza di un gesto o di una risposta verbale come valutazione dello sviluppo.",
        "Scegliere solo oggetti sicuri se il bambino può raggiungerli o manipolarli."
      ],
      "observationSignals": [
        "Il caregiver nomina una persona o un oggetto nel momento in cui è significativo per il bambino.",
        "Il bambino può guardare, indicare, vocalizzare, fare un gesto oppure continuare ciò che stava facendo.",
        "L'adulto risponde a qualunque iniziativa senza correggere o richiedere imitazione."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere una seconda parola o un secondo gesto solo se il bambino resta interessato allo scambio.",
        "ifHard": "Usare una sola persona o cosa molto familiare e limitarsi a nominarla durante l'interazione naturale.",
        "stopRule": "Concludere quando il bambino distoglie l'attenzione, mostra stanchezza o non desidera proseguire."
      },
      "screen": { "classification": "adult-coach-off-screen", "expectedOnScreenSeconds": 15 },
      "diagnosticUse": "none",
      "status": "implemented"
    }
  ]
}
